import React, { useLayoutEffect, useRef } from "react";

/**
 * Rails renders some tool-page content (H1, live answer, amount tables) OUTSIDE
 * #root, so crawlers and no-JS visitors get it in the HTML. This moves that element
 * into its place in the React layout. It's moved, not copied, so it never shows twice.
 */
export const hasServerRenderedBlock = (id: string): boolean =>
  document.getElementById(id) !== null;

const ServerRenderedBlock: React.FC<{ id: string }> = ({ id }) => {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const element = document.getElementById(id);
    if (!element || !ref.current || element.parentElement === ref.current) {
      return;
    }
    // drop the margins/padding it has while it sits outside the React layout
    element.classList.remove("rz-ssr-standalone");
    ref.current.appendChild(element);
  }, [id]);

  if (!hasServerRenderedBlock(id)) return null;
  return <div ref={ref} />;
};

export default ServerRenderedBlock;
